// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2cGOm","content":"ManualTimeModal_content__2pkYN"};